import { useEffect, useState } from 'react'

/**
 * Cards per carousel slide by viewport:
 * <640: 1, <768: 2, <1024: 3, else maxPerSlide (default 4)
 */
const useResponsiveCarouselChunkSize = (maxPerSlide = 4) => {
    const [chunkSize, setChunkSize] = useState(maxPerSlide)

    useEffect(() => {
        const update = () => {
            const width = window.innerWidth
            if (width < 640) setChunkSize(1)
            else if (width < 768) setChunkSize(Math.min(2, maxPerSlide))
            else if (width < 1024) setChunkSize(Math.min(3, maxPerSlide))
            else setChunkSize(maxPerSlide)
        }

        update()
        window.addEventListener('resize', update)
        return () => window.removeEventListener('resize', update)
    }, [maxPerSlide])

    return chunkSize
}

export const gridColsClassForChunk = (chunkSize) => {
    if (chunkSize <= 1) return 'grid-cols-1'
    if (chunkSize === 2) return 'grid-cols-2'
    if (chunkSize === 3) return 'grid-cols-3'
    return 'grid-cols-4'
}

export default useResponsiveCarouselChunkSize
